import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noTilde'
})
export class NoTildePipe implements PipeTransform {

  transform(value: string, args?: any): string {

    let resp: string = value;


    resp = resp.replace(new RegExp(/\s/g), '');
    resp = resp.replace(new RegExp(/[àáâãäå]/g), 'a');
    resp = resp.replace(new RegExp(/[èéêë]/g), 'e');
    resp = resp.replace(new RegExp(/[ìíîï]/g), 'i');
    resp = resp.replace(new RegExp(/[òóôõö]/g), 'o');
    resp = resp.replace(new RegExp(/[ùúûü]/g), 'u');

    resp = resp.replace(new RegExp(/[ÀÁÂÃÄÅ]/g), 'A');
    resp = resp.replace(new RegExp(/[ÈÉÊË]/g), 'E');
    resp = resp.replace(new RegExp(/[ÌÍÎÏ]/g), 'I');
    resp = resp.replace(new RegExp(/[ÒÓÔÕÖ]/g), 'O');
    resp = resp.replace(new RegExp(/[ÙÚÛÜ]/g), 'U');

    return resp;
  }

}



// WEBPACK FOOTER //
// /app/src/app/pipes/no-tilde.pipe.ts